
  
  $(document).on('click','.modal__close .icon, .quick-view-modal-vc .quick-form .quick-form__cta-container .add-to-cart',function() {
    $('.quick-view-modal-vc').removeClass('is_active');
  });
  
  $(document).on('click','ul#sublist .mobile-nav__child-item button',function() {
    $(this).parents('.mobile-nav__sublist.new').addClass('sublist-open');
  });
  
  $(document).on('click','ul.mobile-nav__grandchildlist li:first-child button',function() {
    $('.mobile-nav__sublist.new').removeClass('sublist-open');
  });

  $(document).on('click','ul#sublist .mobile-nav__item:first-child button',function() {
     $('li.mobile-nav__item.appear-animation').removeClass('not-active');
  });
  
  $(document).on('click','li.mobile-nav__link.mobile-nav__item button',function() {
     $('ul#sublist li.mobile-nav__link.mobile-nav__item').addClass('not-active-submenu');
     $(this).parents('li.mobile-nav__link.mobile-nav__item').removeClass('not-active-submenu');
  });
  
  $(document).on('click','li.sub-child-grand, ul#sublist .mobile-nav__item:first-child button',function() {
     $('ul#sublist li.mobile-nav__link.mobile-nav__item').removeClass('not-active-submenu');
  });
  
  $(document).on('click','.mobile-nav__has-sublist button',function() {
     $('li.mobile-nav__item.appear-animation').addClass('not-active');
     $(this).parents('li.mobile-nav__item.appear-animation').removeClass('not-active');
  });

 $(document).on('click','div#buttonme.sticky-cart-button',function() {
     if($('div#buttonme.sticky-cart-button span').text() == 'Proceed to Payment') {
       window.location.href = '/checkout'; 
     } else {
     if($('.buttn-quant button.btn.add-to-cart').hasClass('disabled')) {
       $('html, body').animate({
          scrollTop: $(".product-block .variant-wrapper").offset().top
       }, 500);
       $('.variant-wrapper.js [name=Size]').parent('.variant-wrapper').find('label.variant__label').append('<span class="size_validation" style="color:#ff0000; text-transform:none;">Select a Size</span>');
       setTimeout(function() {
         $('.size_validation').remove();
       },3000);
     } else {
       $('.buttn-quant button.btn.add-to-cart').click();
       $('div#buttonme.sticky-cart-button span').html('Proceed to Payment');
     }
     }
  });

  $(document).on('click','.buttn-quant button.btn.add-to-cart',function() {
    $('div#buttonme.sticky-cart-button span').html('Proceed to Payment');
  });

$(document).on('click','.cart_notes label[for="CartNoteDrawer1"]',function() {
     $(this).toggleClass('active-note');
     $('.cart_notes .cart-notes-field').slideToggle();
  });

  $(document).on('click','.cart_notes button.Button',function() {
            $('.cart_notes .cart-notes-field').hide();
            value = $('.cart_notes textarea#CartNoteDrawer').val();
            if(value == '') {
              $('.cart_notes label[for="CartNoteDrawer"]').html('Add Order Note');
            } else {
              $('.cart_notes label[for="CartNoteDrawer"]').html('Edit Order Note');
            }
            $.ajax({
        		url: '/cart/update.js',
        		type: 'POST',
        		data: {note: value}
        	});
  });

$('.product-single__meta .variant-wrapper.js [name=Size], .product-single__meta .variant-wrapper.js [name=size]').click(function() {
   setTimeout(function() {
   if($('button.add-to-cart').hasClass('disabled')) {
      $('button#SI_trigger').show();
      $(this).find('span').html('Sold Out');
   } else {
      $('button#SI_trigger').hide();
      $(this).find('span').html('Add to cart');
   }
   },1000);
  });

 $(document).on('click','p.sfl_p.wishlist_cart a.sfl',function() {
        WishlistKing.toolkit.addProduct(
          $(this).attr('productid'),
          $(this).attr('variantid')
        );
        $(this).parents('.cart__item-details').find('.cart__remove a').click();
   });